import { render, staticRenderFns } from "./LoggiMessage.vue?vue&type=template&id=cc2f2f9e&scoped=true"
import script from "./LoggiMessage.vue?vue&type=script&lang=js"
export * from "./LoggiMessage.vue?vue&type=script&lang=js"
import style0 from "./LoggiMessage.vue?vue&type=style&index=0&id=cc2f2f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2f2f9e",
  null
  
)

export default component.exports